import React, { useEffect, useState } from 'react';
import classes from './style.module.scss';
import Footer from '../Footer/Footer';
import NewsItem from '../NewsItem/NewsItem';

const News = () => {
    const [news, setNews] = useState([]);
    useEffect(() => {
        async function main() {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_API}/news`,
            );
            const result = await response.json();
            setNews(result.news.items);
        }

        main();
    }, []);

    return (
        <div className={classes.page}>
            <div className={classes.container}>
                {news.map((item, key) => (
                    <div key={key}>
                        <NewsItem news={item} />
                    </div>
                ))}
            </div>
            <Footer />
        </div>
    );
};

export default News;
